const def = {
    "letter_not_found": "Letter is not found",
    "security_code": "What is the security code of the letter?\n\nPlease check the SMS you received before to find the security code.",
    "letter_seen_email_subject": "SMS Letter is Seen!",
    "letter_seen_email_html": "Hey <b>[0]</b>, <br /> <br />The SMS Letter is seen by the receiver.<br /> <br /> <b>Letter Link: </b> [1] <br /> <br /> <b>Thank you for choosing us</b>",
    "block_prompt": "Are you sure to block the sender?",
    "block_alert": "Sender is blocked!",
    "error_on_playing_music": "Error happens on playing music! Please refresh the page. \nIf the problem is not solved, please check the music link format!\nIt should be like in the below.\nhttps://www.youtube.com/watch?v=nOgEMfMl4jk"

};

const tr = {
    "letter_not_found": "Mektup Bulunamadı",
    "security_code": "Mektubun güvenlik kodu nedir?\n\nLütfen aldığınız SMS'i kontrol edip, gelen güvenlik kodunu giriniz.",
    "letter_seen_email_subject": "SMS Mektubu Görüldü!",
    "letter_seen_email_html": "Merhaba <b>[0]</b>, <br /> <br />SMS mektubu alıcı tarafından görüldü.<br /> <br /> <b>Mektup Kimliği: </b> [1] <br /> <br /> <b>Bizi seçtiğiniz için teşekkür ederiz.</b>",
    "block_prompt": "Göndericiyi engellemek istediğinizden emin misiniz?",
    "block_alert": "Gönderici engellendi!",
    "error_on_playing_music": "Müzik başlatılırken hata oluştu! Lütfen sayfayı yenileyin. \nEğer sorun düzelmezse, müzik link formatı hatalı olabilir!\nAşağıdaki gibi olmalıdır.\nhttps://www.youtube.com/watch?v=nOgEMfMl4jk"
};

const locales = {
    "tr": tr,
};

export const localize = (key, locale) => {
    const _locale = locales[locale] ?? def;
    return _locale[key];
}